let gqlClient;

export function initGQL (initGQL) {
  gqlClient = initGQL;
}

export function useGQL () {
  return gqlClient;
}
